import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from 'app.config';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HomeService {
    actionRequiredNum = 0;
    actionExprising = 0;
    actionComplete = 0;
    actionWaiting = 0;
    actionNotification = 0;
    fullName: string;
    userName: string;
    profileImage;

    constructor(
        private httpHelper: HttpHelper) {
        // firestore.collection('envelopes').doc('envelopes').collection('dang.phan.2@vng.com.vn').valueChanges().subscribe((data)=>{
        //     console.log(data);
        // });
    }

    getPagingRequest() {
        const data = { "startRow": 0, "endRow": 50, "rowGroupCols": [], "valueCols": [], "pivotCols": [{ "id": "status", "displayName": "Status", "field": "status" }, { "id": "requestType", "displayName": "Request Type", "field": "requestType" }, { "id": "departmentCode", "displayName": "Department Code", "field": "departmentCode" }, { "id": "remainByRr", "displayName": "Remain by RR", "field": "remainByRr" }, { "id": "requester", "displayName": "Requester", "field": "requester" }], "pivotMode": false, "groupKeys": [], "filterModel": { "status": { "filterType": "set", "values": ["DRAFT", "WAITING_HRBP", "WAITING_DEPT", "WAITING_RRM", "INPROCESS"] }, "fullWaitingOnboardFlg": { "filterType": "set", "values": [0] } }, "sortModel": [{ "colId": "createTime", "sort": "desc" }, { "colId": "statusPriority", "sort": "asc" }] };
        return this.httpHelper.methodPostJsonService(APP_CONFIG.MCRHRRCRT + 'requisition/pivotPagingAssignedRequistion', data);
    }

    getDataDashBoard(fromDate, toDate) {
        const params = new HttpParams()
            .set('fromDate', fromDate)
            .set('toDate', toDate)
        return this.httpHelper.methodGetObservableService(`${APP_CONFIG.MCRHRRCRT}requisition/getRequisitionOverview`, APP_CONFIG.QUERY_TIME_OUT, params).pipe(map((value) => value.data))
    }

    clearData(): void {
        this.actionRequiredNum = 0;
        this.actionExprising = 0;
        this.actionComplete = 0;
        this.actionWaiting = 0;
        this.actionNotification = 0;
        this.fullName = '';
        this.profileImage = null;
    }

}
